import { render, staticRenderFns } from "./MatchingPhonicsForm.vue?vue&type=template&id=970365e6&"
import script from "./MatchingPhonicsForm.vue?vue&type=script&lang=js&"
export * from "./MatchingPhonicsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports